export default __webpack_public_path__ + "static/media/ritual3.6c5277d7.png";